import { render } from "./expenses-table.vue?vue&type=template&id=728b6b89"
import script from "./expenses-table.vue?vue&type=script&lang=js"
export * from "./expenses-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__